import { useState } from "react";
import {
  AiFillGithub,
  AiFillInstagram,
  AiFillLinkedin,
  AiFillTwitterCircle,
} from "react-icons/ai";
import { GrMail } from "react-icons/gr";
import { ImAddressBook, ImPhone } from "react-icons/im";
import "../Css/home.css";
import Headings from "../components/Headings";
import Image from "../components/Image";
import { imges, navbar } from "../json/data";

export default function Contact() {
    const [user, setUser] = useState({
      name: "",
      email: "",
      phone: "",
      message: "",
    });

    const handleChange = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      setUser({ ...user, [name]: value });
    };
  console.log(user);

  const formClick = async (e) => {
    e.preventDefault();
    const { name, email, phone, message } = user;

    const res = await fetch("https://abu-azhar.onrender.com", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name,
        email,
        phone,
        message,
      }),
    });

    const data = await res.json();
    console.log(data)
    if (!data.success) {
      alert("Please fill Correct Data")
    } else {
      alert("Thank you for connecting with us");
      setUser({ name: "", email: "", phone: "", message: "" }); // Reset the form
    }
  };
  return (
    <div className="Contact">
      {imges.slice(4, 5).map((pic, i) => {
        return <Image key={i} pictures={pic.img} />;
      })}{" "}
      <div className="Right-contact">
        {navbar.slice(3, 4).map((data, index) => {
          return (
            <Headings
              key={index}
              topDiscription={data.name}
              heading={data.heading}
            />
          );
        })}
        <div className="form">
          <div className="contact-heading">
            <h3>Say SomeThing</h3>
          </div>
          <form action="/" method="post">
            <div className="name-email">
              <input
                value={user.name}
                onChange={handleChange}
                type="text"
                name="name"
                placeholder="Name *"
                required
              />
              <input
                value={user.email}
                onChange={handleChange}
                type="email"
                name="email"
                placeholder="Email *"
                required
              />
            </div>
            <input
              value={user.phone}
              onChange={handleChange}
              type="tel"
              name="phone"
              className="number"
              placeholder="Number *"
              required
            />
            <textarea
              cols="30"
              className="textarea"
              placeholder="Your message *"
              rows="10"
              value={user.message}
              onChange={handleChange}
              name="message"
            ></textarea>
            <div className="form-button">
              <button type="submit" onClick={formClick}>SEND MESSAGE</button>
            </div>
          </form>
        </div>
        <div className="Address-content">
          <h2>CONTACT INFO</h2>
          <p>
            I am available for freelance work. Connect with me email and call in
            to my account.
          </p>
          <p>
            <ImAddressBook className="contact-icons" />
            Address :{" "}
            <span>[ India, Uttar Pradesh, Saharanpur, pincode : 247001 ]</span>
          </p>
          <p>
            <ImPhone className="contact-icons" />
            Phone : <span>+917454961965</span>
          </p>
          <p>
            <GrMail className="contact-icons" />
            Email : <span>74abuazhar@gmail.com</span>
          </p>
          <div className="social-icons">
            <span>FIND ME ON :</span>
            <a href="https://www.linkedin.com/in/abu-azhar-a41288227/">
              <AiFillLinkedin />
            </a>
            <a href="https://twitter.com/AbuAzhar_">
              <AiFillTwitterCircle />
            </a>
            <a href="https://www.instagram.com/_abu_azhar__/">
              <AiFillInstagram />
            </a>
            <a href="https://github.com/AbuAzhar">
              <AiFillGithub />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
